<template>
  <div class="board-wrap">
    <div class="fight-info">
      <div class="fight-title">
        <div>
          <div class="f-title c-saru">SARU</div>
          <div class="f-power c-saru">
            <b-skeleton v-if="loading"></b-skeleton>
            <div class="d-flex" v-else>
              <div class="power-col">
                <div class="value">
                  {{ utils.bigToCommon(saruTotal, 18, 2) }}
                </div>
                <div class="note">Total</div>
              </div>
              <div class="power-col">
                <div class="value">
                  {{ utils.bigToCommon(score.saru, 18, 2) }}
                </div>
                <div class="note">Score</div>
              </div>
            </div>
          </div>
        </div>
        <div class="f-vs">
          <div class="title">VS</div>
          <div>
            <b-skeleton v-if="loading"></b-skeleton>
            <div class="power-col" v-else>
              <span class="value">
                {{ mData.stage }}
              </span>
              <div class="note">stage</div>
            </div>
          </div>
        </div>
        <div>
          <div class="f-title c-nioh">nioh</div>
          <div class="f-power c-nioh">
            <b-skeleton v-if="loading"></b-skeleton>
            <div class="d-flex" v-else>
              <div class="power-col">
                <div class="value">
                  {{ utils.bigToCommon(niohTotal, 18, 2) }}
                </div>
                <div class="note">Total</div>
              </div>
              <div class="power-col">
                <div class="value">
                  {{ utils.bigToCommon(score.nioh, 18, 2) }}
                </div>
                <div class="note">Score</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fight-power">
        <table class="power">
          <thead>
            <tr>
              <th class="t-icon"></th>
              <th class="t-value">
                <img
                  class="k-icon"
                  src="~@/assets/icons/attack.png"
                  v-b-tooltip.hover
                  title="ATTACK"
                />
              </th>
              <th class="t-value">
                <img
                  class="k-icon"
                  src="~@/assets/icons/defend.png"
                  v-b-tooltip.hover
                  title="DEFEND"
                />
              </th>
              <th class="t-value">
                <img
                  class="k-icon"
                  src="~@/assets/icons/attack.png"
                  v-b-tooltip.hover
                  title="ATTACK"
                />
              </th>
              <th class="t-value">
                <img
                  class="k-icon"
                  src="~@/assets/icons/defend.png"
                  v-b-tooltip.hover
                  title="DEFEND"
                />
              </th>
              <th class="t-icon"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.icon">
              <td>
                <b-img
                  v-b-tooltip.hover
                  :title="item.key.toLocaleUpperCase()"
                  class="icon-item"
                  :src="item.icon"
                />
              </td>
              <td class="c-saru">
                <b-skeleton v-if="loading"></b-skeleton>
                <span v-else>{{ utils.bigToCommon(item.sAtt, 18, 2) }}</span>
              </td>
              <td class="c-saru">
                <b-skeleton v-if="loading"></b-skeleton>
                <span v-else>{{ utils.bigToCommon(item.sDef, 18, 2) }}</span>
              </td>
              <td class="c-nioh">
                <b-skeleton v-if="loading"></b-skeleton>
                <span v-else>{{ utils.bigToCommon(item.nAtt, 18, 2) }}</span>
              </td>
              <td class="c-nioh">
                <b-skeleton v-if="loading"></b-skeleton>
                <span v-else>{{ utils.bigToCommon(item.nDef, 18, 2) }}</span>
              </td>
              <td>
                <b-img
                  v-b-tooltip.hover
                  :title="item.key.toLocaleUpperCase()"
                  class="icon-item"
                  :src="item.icon"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-skeleton
        v-if="loading"
        type="button"
        width="300px"
        class="mx-auto"
      ></b-skeleton>
      <div v-else class="f-action d-flex justify-content-center">
        <b-overlay
          :show="busy"
          rounded
          opacity="0.1"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block btn-fight"
        >
          <b-button
            class="btn-fight btn-allow"
            ref="button"
            :disabled="busy"
            variant="primary"
            @click="onFighting(false)"
          >
            Fight
          </b-button>
        </b-overlay>
        <b-overlay
          :show="isEarn"
          rounded
          opacity="0.1"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block btn-fight"
        >
          <b-button
            class="btn-fight btn-boost"
            ref="button"
            :disabled="isEarn"
            variant="primary"
            @click="onFighting(true)"
          >
            Fight & Boost
          </b-button>
        </b-overlay>
      </div>
    </div>
    <Victory
      :show="won"
      :geTitle="geTitle"
      @onEarn="onEarn"
      @onClose="won = false"
      :reward="rewardGE"
      :yourRate="yourRate"
    />
    <Loser
      :geTitle="geTitle"
      :show="isLoser"
      @onClose="isLoser = false"
      :reward="rewardGE"
      @onFightAgain="onFightAgain"
    />
  </div>
</template>

<script>
import iSlash from "@/assets/icons/slash.png";
import iHeavy from "@/assets/icons/heavy.png";
import iStrike from "@/assets/icons/strike.png";
import iTech from "@/assets/icons/tech.png";
import iMagic from "@/assets/icons/magic.png";
import Victory from "./Victory.vue";
import Loser from "./Loser.vue";
import { CoreGame } from "@/amakunicom/sdk";
import { ethers } from "ethers";
import { mapActions, mapGetters } from "vuex";

const zero = ethers.constants.Zero;
const KEY_EVENT_LOAD_SARU = "saru-load-data";
const KEY_EVENT_LOAD_IMPORT = "saru-load-import";

export default {
  props: ["mData"],
  computed: mapGetters("saru", ["toTokenIds", "toItemIds"]),
  data: () => ({
    tokenIds: [],
    busy: false,
    geTitle: null,
    isEarn: false,
    won: false,
    isLoser: false,
    rewardGE: zero,
    saruTotal: ethers.constants.Zero,
    niohTotal: ethers.constants.Zero,
    score: {
      saru: ethers.constants.Zero,
      nioh: ethers.constants.Zero,
    },
    items: [
      {
        icon: iTech,
        sAtt: zero,
        sDef: zero,
        nAtt: zero,
        nDef: zero,
        key: "tech",
      },
      {
        icon: iMagic,
        sAtt: zero,
        sDef: zero,
        nAtt: zero,
        nDef: zero,
        key: "magic",
      },
      {
        icon: iSlash,
        sAtt: zero,
        sDef: zero,
        nAtt: zero,
        nDef: zero,
        key: "slash",
      },
      {
        icon: iHeavy,
        sAtt: zero,
        sDef: zero,
        nAtt: zero,
        nDef: zero,
        key: "heavy",
      },
      {
        icon: iStrike,
        sAtt: zero,
        sDef: zero,
        nAtt: zero,
        nDef: zero,
        key: "strike",
      },
    ],
    loading: true,
    yourRate: ethers.constants.Zero,
    itemList: [],
    itemMeta: {},
  }),
  components: { Victory, Loser },
  async created() {
    this.signer = await this.provider.getSigner();
    this.account = await this.signer.getAddress();
    this.tokens = this.getCoreConfig();
    this.game = await CoreGame.initWith(
      this.tokens,
      this.provider,
      this.signer
    );
    await this.loadNFT();
    this.loadData();
    this.$eventBus.$on(KEY_EVENT_LOAD_SARU, this.onLoadData);
    this.$eventBus.$on(KEY_EVENT_LOAD_IMPORT, this.loadNFT);
  },
  methods: {
    ...mapActions("saru", ["updateTeam", "getMetaByTokenId", "updateMeta"]),
    async onLoadData() {
      try {
        this.tokenIds = (await this.toTokenIds).map(({ tokenId }) => tokenId);
        this.itemList = await this.toItemIds;
      } catch (err) {
        console.log(err);
      }
      this.loadData();
    },
    async loadNFT() {
      const stage = await this.game.stageOf(this.account);
      let str = "";
      // 1. query
      // 2. import
      // 3. get local
      // 4. random foundation
      const tmp = await this.mStore.getImportTeam();
      let ids = true;
      if (this.$route.query.ids) {
        str = this.$route.query.ids;
        this.mSession.setFighting(str);
      } else if (tmp) {
        ids = this.callTeam(stage, tmp);
      } else if (this.mSession.getFighting()) {
        str = this.mSession.getFighting();
      }

      try {
        if (str && ids) {
          [this.tokenIds, this.itemList] = this.utils.decodeShareLink(str);
          if (!this.$route.query.full) {
            this.tokenIds = this.tokenIds.slice(0, 6);
            this.itemList = this.itemList.slice(0, 6);
          }
        }
      } catch (err) {
        console.log(err);
        this.mSession.removeItem();
      }
      if (this.tokenIds.length === 0) {
        this.tokenIds = await this.game.nftScholar(this.tokens.kuniSaru);
        let len = this.getSize(stage);
        this.tokenIds = this.tokenIds.slice(0, len);
        this.itemList = this.itemList.slice(0, len);
      }
      this.$store.dispatch("saru/updateTeam", {
        tokenIds: this.tokenIds,
        itemIds: this.itemList,
      });

      const items = [];
      this.itemList.forEach((item) => {
        items.push(...item.filter((k) => ethers.BigNumber.from(k).gt(0)));
      });
      this.updateFetchMeta(items);
    },
    getSize(stage) {
      let len = 6;
      if (stage < 9n) {
        len = 1;
      } else if (stage >= 9n && stage < 14n) {
        len = 2;
      } else if (stage >= 14n && stage < 17n) {
        len = 3;
      } else if (stage >= 17n && stage < 20n) {
        len = 4;
      } else if (stage >= 20n && stage < 24n) {
        len = 5;
      }
      return len;
    },
    async loadData() {
      const self = this;
      this.game
        .getPowerFight(this.tokenIds, this.account, this.itemList)
        .then(({ saru, nioh, score }) => {
          this.loading = false;
          self.saruTotal = saru.total;
          self.niohTotal = nioh.total;
          self.score = score;
          self.items.forEach(function (item) {
            item.sAtt = saru.attack[item.key];
            item.sDef = saru.defend[item.key];
            item.nAtt = nioh.attack[item.key];
            item.nDef = nioh.defend[item.key];
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async onFightAgain() {
      this.isLoser = false;
      await this.onFighting();
      this.$emit("onLoadData");
    },
    async onFighting(isEarn) {
      if (isEarn) {
        this.geTitle = null;
        this.isEarn = true;
      } else {
        this.geTitle = "GE";
        this.busy = true;
      }

      const self = this;
      try {
        const tx = await this.game.fightingExt(
          this.tokenIds,
          this.itemList,
          isEarn
        );
        await tx.wait();
        await this.loadNFT();
        self.loadData();
        this.$emit("onLoadData");
        const { ge, won } = await this.game.getEventFighting(`${tx.hash}`);
        self.rewardGE = ge;
        if (won) {
          this.yourRate = await this.game.geStakedOf(this.account);
          self.won = true;
        } else {
          self.isLoser = true;
        }
      } catch (err) {
        this.$bvToast.toast(
          err.reason || err.message || "KUNI: Unable to process request",
          {
            variant: "warning",
            autoHideDelay: 3000,
            title: "Warning",
          }
        );
      } finally {
        self.busy = false;
        this.isEarn = false;
      }
    },
    async onEarn() {
      try {
        await (await this.game.earnKuni()).wait();
        this.$emit("onLoadData");
      } catch (error) {
        this.$bvToast.toast("KUNI: Unable to process request", {
          variant: "warning",
          autoHideDelay: 3000,
          title: "Warning",
        });
      } finally {
        this.won = false;
      }
    },
    async updateFetchMeta(tokenIds) {
      if (tokenIds.length > 0) {
        const data = await this.game.fetchItemMeta(
          this.tokens.kuniItem,
          tokenIds
        );
        const meta = this.$_.keyBy(data.data, ({ tokenId }) => Number(tokenId));
        this.$store.dispatch("saru/updateMeta", { meta });
      }
      return {};
    },
    callTeam(stage, val) {
      try {
        let { team } = this.mStore.decrypt(val);
        [, team] = this.utils.toImportTeam(team.split(/\r\n|\n|\r/));
        team = team[Number(stage)];
        if (team) {
          this.tokenIds = team.tokenIds;
          this.itemList = team.itemList;
          return false;
        }
      } catch (error) {
        console.log(error);
        this.mStore.removeImportTeam();
      }
      return true;
    },
  },
  beforeDestroy() {
    this.$eventBus.$off(KEY_EVENT_LOAD_SARU, this.loadData);
    this.$eventBus.$off(KEY_EVENT_LOAD_IMPORT, this.loadNFT);
  },
};
</script>

<style lang="scss" scoped>
.board-wrap {
  // margin-top: 42px;
  display: flex;
  justify-content: space-between;
  text-transform: lowercase;
  padding: 16px;
  .fight-info {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 0 auto;
    .fight-title {
      color: #fff;
      font-family: Bebas Neue;
      text-align: center;
      display: flex;
      justify-content: center;
      gap: 16px;
      align-items: center;
      font-size: 36px;
      font-weight: 400;
      line-height: normal;
      div {
        &:first-child,
        &:last-child {
          flex: 1;
        }
      }
      .power-col {
        .value {
          font-size: 20px;
          line-height: 24px;
        }
        .note {
          font-size: 15px;
          color: #afb1b6;
          text-transform: lowercase !important;
          line-height: 18px;
        }
      }
      .f-vs {
        // font-size: 60px;
        // line-height: 76px;
        font-size: 30px;
        line-height: 36px;
      }
      .f-power {
        font-size: 30px;
        line-height: 36px;
        text-align: center;
        font-weight: 400;
      }
      .f-title {
        font-size: 36px;
        font-weight: 400;
        line-height: 43px;
      }
    }
    .fight-power {
      position: relative;
      background: #eb345f;
      width: 870px;
      min-height: 303px;
      margin-top: 20px;
      margin-bottom: 25px;
      clip-path: polygon(
        0 50px,
        50px 0,
        100% 0,
        100% calc(100% - 50px),
        calc(100% - 50px) 100%,
        0 100%
      );
      .power {
        border-collapse: collapse;
        table-layout: fixed;
        position: absolute;
        top: 1px;
        left: 1px;
        right: 1px;
        bottom: 1px;
        width: calc(100% - 2px);
        text-align: center;
        // clip-path: inset(0 0 0 round 30px 0);
        clip-path: polygon(
          0 50px,
          50px 0,
          100% 0,
          100% calc(100% - 50px),
          calc(100% - 50px) 100%,
          0 100%
        );
        background-color: #14101a;
        border: 1px solid #eb345f;
        .k-icon {
          cursor: pointer;
          max-width: 20px;
          margin: 0 auto;
        }
        thead {
          // background-color: rgba(0, 0, 0, 0.5);
          tr {
            height: 50px;
            th {
              &:nth-child(3) {
                border-right: 1px solid rgba(255, 255, 255, 0.2);
              }
              &:first-child,
              &:last-child {
                width: 100px;
              }
            }
          }
        }
        tbody {
          tr {
            height: 50px;
            &:nth-child(2n) {
              border-top: 1px solid #472f6b;
              background: linear-gradient(
                180deg,
                rgba(71, 47, 107, 0) 0%,
                rgba(71, 47, 107, 0.5) 100%
              );
            }
            td {
              text-align: center;
              .icon-item {
                cursor: pointer;
                width: 20px;
                margin: 0 auto;
              }
              &:nth-child(3) {
                border-right: 1px solid rgba(255, 255, 255, 0.2);
              }
            }
          }
        }
      }
    }

    .c-saru {
      color: #25ffde;
      font-size: 20px;
      font-weight: 600;
      line-height: 25px;
    }

    .c-nioh {
      color: #eb345f;
      font-size: 20px;
      font-weight: 600;
      line-height: 25px;
    }
    .c-icon {
      width: 40px;
      height: 40px;
    }
  }
  .f-action {
    gap: 16px;
  }
  .btn-fight {
    &.btn-not-allowed {
      background: url("~@/assets/icons/btn-button-disable.svg");
      cursor: not-allowed;
    }
    &.btn-allow {
      cursor: pointer;
      background: url("~@/assets/icons/btn-button.svg");
      background-size: cover;
    }
    &.btn-boost {
      background: url("~@/assets/icons/btn-boost.svg");
      background-size: cover;
    }
    border: none;
    width: 202px;
    height: 62px;
    flex-shrink: 0;
    color: #fff;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 0.72px;
    &:active,
    &:focus {
      border: none;
      box-shadow: none;
    }
  }
  @media (max-width: 991px) {
    padding: 0 16px;
    .fight-info {
      .fight-power {
        width: 727px;
        clip-path: polygon(
          0 50px,
          50px 0,
          100% 0,
          100% calc(100% - 50px),
          100% 100%,
          0 100%
        );
        .power {
          border-collapse: collapse;
          table-layout: fixed;
          clip-path: polygon(
            0 50px,
            50px 0,
            100% 0,
            100% calc(100% - 50px),
            100% 100%,
            0 100%
          );
          thead {
            tr {
              height: 50px;
              th {
                &.t-icon {
                  width: 25px;
                }
                &:nth-child(3) {
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                }
              }
            }
          }
          tbody {
            tr {
              td {
                &:nth-child(2),
                &:nth-child(4),
                &:nth-child(5) {
                  width: calc(25% - 30px) !important;
                }
                &:nth-child(3) {
                  width: calc(25% - 30px) !important;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                }
                &:last-child {
                  padding-right: 4px !important;
                }
                &:first-child {
                  padding-left: 4px !important;
                }
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 767px) {
    padding: 0 16px;
    .fight-info {
      .fight-power {
        width: 536px;
        .power {
          tbody {
            tr {
              td {
                font-size: 18px;
              }
            }
          }
        }
      }
      .fight-title {
        .f-title {
          font-size: 30px;
          line-height: 36px;
        }
        .f-power {
          font-size: 24px;
          line-height: 28px;
        }
        .f-vs {
          //   font-size: 24px;
          //   line-height: 28px;
          font-size: 24px;
          line-height: 28px;
        }
      }
    }
    .btn-fight {
      height: 48px;
      width: 158px;
      font-size: 20px;
      background-size: cover;
    }
  }
  @media (max-width: 576px) {
    padding-left: 0;
    padding-right: 0;
    .fight-info {
      width: 100%;
      .fight-power {
        width: 100%;
        .power {
          tbody {
            tr {
              td {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
